import { createSlice } from '@reduxjs/toolkit'

import { SLICES } from '@/reducers/utils/constants'

import { extraReducers, reducers } from './reducers'

export const initialState = {
  b2bLink: '',
  bookshelf: {
    link: '',
    text: ''
  },
  firstName: '',
  hideFacultySamplingLink: '',
  isGuestReferenceUser: false,
  isLoggedIn: false,
  lastName: '',
  navigation: {
    backofficePermissions: [],
    canRedeem: false,
    hasDashboard: false,
    hasInstructorExperience: false,
    hasNonVstAdminBackofficeAccess: false,
    hasRoleBasedDashboard: false,
    roleBasedDashboardPath: '',
    samplingDashboardLink: '',
    samplingRecommendationsLink: ''
  }
}

const mobileMenu = createSlice({
  extraReducers,
  initialState,
  name: SLICES.mobileMenu,
  reducers
})

export const { actions } = mobileMenu
export default mobileMenu
